//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['currentPage', 'total', 'limit', 'layout', 'goTop'],
  data() {
    return {
      internalCurrentPage: 1,
      lastEmittedPage: -1,
      setting: {
        prev: false,
        next: false,
        jumper: false,
      },
      needGoTop: false,
    };
  },
  computed: {
    re_pageSize() {
      return Math.ceil(this.total / this.limit);
    },
    pagers() {
      const pageInfo = {
        firstPage: 1,
        showPrevMore: false,
        pagers: [2, 3, 4, 5],
        showNextMore: false,
        lastPage: null,
      };
      const re_pageSize = this.re_pageSize;
      const currentPage = this.currentPage;

      if (re_pageSize < 7) {
        pageInfo.pagers = [];
        for (let i = 2; i < re_pageSize + 1; i++) {
          pageInfo.pagers.push(i);
        }
      } else if (re_pageSize === 7) {
        pageInfo.pagers = [];
        for (let i = 2; i < re_pageSize; i++) {
          pageInfo.pagers.push(i);
        }
        pageInfo.lastPage = re_pageSize;
      } else if (re_pageSize > 7) {
        if (currentPage < 5) {
          pageInfo.pagers = [2, 3, 4, 5, 6];
          pageInfo.showNextMore = true;
          pageInfo.lastPage = re_pageSize;
        } else if (currentPage > re_pageSize - 4) {
          pageInfo.pagers = [];
          for (let i = re_pageSize - 5; i < re_pageSize; i++) {
            pageInfo.pagers.push(i);
          }
          pageInfo.lastPage = re_pageSize;
          pageInfo.showPrevMore = true;
        } else {
          pageInfo.pagers = [];
          for (let i = currentPage - 2; i < currentPage + 3; i++) {
            pageInfo.pagers.push(i);
          }
          pageInfo.lastPage = re_pageSize;
          pageInfo.showPrevMore = true;
          pageInfo.showNextMore = true;
        }
      }
      return pageInfo;
    },
  },
  watch: {
    currentPage() {
      this.internalCurrentPage = this.currentPage;
    },
  },
  created() {
    const settinglist = ['prev', 'next', 'jumper'];
    this.needGoTop = this.goTop ? true : false;
    if (this.layout) {
      settinglist.forEach((item) => {
        if (this.layout.includes(item)) {
          this.setting[item] = true;
        } else {
          this.setting[item] = false;
        }
      });
    }
  },
  methods: {
    inputChange(v) {
      const pageNumber =
        v.srcElement.valueAsNumber > this.re_pageSize
          ? this.re_pageSize
          : v.srcElement.valueAsNumber;
      this.internalCurrentPage = pageNumber;
      this.theEmit();
    },
    changeMore(type) {
      switch (type) {
        case 'prev':
          this.changePage(this.pagers.pagers[0] - 1);
          break;
        case 'next':
          this.changePage(
            this.pagers.pagers[this.pagers.pagers.length - 1] + 1
          );
          break;
        default:
      }
    },
    changePage(type) {
      switch (type) {
        case 'prev':
          if (this.internalCurrentPage === 1) return;
          this.internalCurrentPage -= 1;
          break;
        case 'next':
          if (this.internalCurrentPage === this.re_pageSize) return;
          this.internalCurrentPage += 1;
          break;
        default:
          this.internalCurrentPage = parseInt(type);
      }
      this.theEmit();
    },
    theEmit() {
      this.lastEmittedPage = this.internalCurrentPage;
      this.$emit('current-change', this.internalCurrentPage);
      if (this.needGoTop) {
        document.querySelector('body').scrollIntoView();
      }
    },
  },
};
